import IssbContainer from "../IssbContainer";
import { Button, Divider, Flex, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import SourcesListPanel from "../Sources/SourcesListPanel";
import { useSelector } from "react-redux";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import RoundList from "../components/NavItems/RoundList";
import { routes } from "../../../config/paths";
import { useTranslation } from "react-i18next";
import DataInputPage from "../IssbDataInput/DataInputPage";
import useAirUserRoles from "../../../utils/AuthUtils";
import withAuthorization from "../../../context/Auth/WithAuthorization";
import AIDashboard from "../Dashboard/components/AIDashboard/AIDashboard";
import AuditDashboard from "../Dashboard/AuditDashboard";
import { Tasks } from "../Dashboard/components/Tasks";
import Status from "../Dashboard/components/Status/Status";
import SecondaryHeader from "../components/SecondaryHeader";

const IssbRequirementsPage = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [panelOpen, setPanelOpen] = useState(false);

  const { isOrgAdmin, isESGAdmin, canAccessEntity } = useAirUserRoles();

  const tabIndex = parseInt(searchParams.get("rtab")) || 0;
  const [selectedTab, setSelectedTab] = React.useState(tabIndex);
  const setTabIndex = (index) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("rtab", index);
    setSearchParams(newParams);
    setSelectedTab(index);
  };

  useEffect(() => {
    const newTabIndex = parseInt(searchParams.get("rtab")) || 0;
    setSelectedTab(newTabIndex);
  }, [searchParams]);

  const { t } = useTranslation("translation", {
    keyPrefix: "issb.requirementPage.titles",
  });

  const roundSelector = useSelector((state) => state.issbRound);
  const questionList = roundSelector?.questions;

  const handleStartRound = () => {
    navigate(routes.issbQuestionnaireRoundSetup);
  };

  if (!canAccessEntity()) {
    return (
      <IssbContainer margin="15%">
        <Text>You don't have access to this entity</Text>
      </IssbContainer>
    );
  }

  return (
    <SecondaryHeader onPanelChange={(panel) => setPanelOpen(!!panel)}>
      <IssbContainer margin={panelOpen ? "5%" : "15%"}>
        <Flex justify="space-between" align="center" mb={-4}>
          <Text fontSize="heading.3xl" fontWeight="700" color="darkTeal">
            Disclosure Builder
          </Text>
          {isESGAdmin && (
            <Button as={Link} to={routes.issbCompareReviews} variant="secondary" size="sm">
              Compare AI Reviews
            </Button>
          )}
        </Flex>
        <Tabs
          variant="primary"
          isLazy={true}
          index={tabIndex}
          onChange={setTabIndex}
        >
          <TabList>
            <Tab>Round Status</Tab>
            <Tab>Requirements</Tab>
            <Tab>AI Review</Tab>
            <Tab>Internal Audit</Tab>
            <Tab>Sources</Tab>
          </TabList>

          <Divider />

          <Text maxW="75%" color="gray.500" fontSize="body.m" mt={4}>
            {t(selectedTab)}
          </Text>

            {roundSelector?.selectedRound ? (
              <TabPanels>
                <TabPanel px={0}>
                  <Flex direction="column" gap={6}>
                    <Tasks questions={questionList} />
                    <Status questions={questionList} />
                  </Flex>
                </TabPanel>
                <TabPanel px={0}>
                  <DataInputPage />
                </TabPanel>
                <TabPanel px={0}>
                  <AIDashboard />
                </TabPanel>
                <TabPanel px={0}>
                  <AuditDashboard />
                </TabPanel>
                <TabPanel px={0}>
                  <SourcesListPanel />
                </TabPanel>
              </TabPanels>
            ) : (
              <div>
                <Text color="darkTeal" fontSize="body.m" my={4}>
                  Please select a round to get started
                </Text>
                <RoundList variant="secondary" />
                <Divider mt={4} mb={4} />
                {isOrgAdmin && (
                  <div>
                    Or{" "}
                    <Button ml={2} variant="secondary" onClick={handleStartRound}>
                      Create a new round
                    </Button>
                  </div>
                )}
              </div>
            )}
          </Tabs>
      </IssbContainer>
    </SecondaryHeader>
  );
};

export default withAuthorization(IssbRequirementsPage);
